<mat-toolbar
  class="bar"
  *ngIf="!hidePageConfirmationPlatform && !hidePageConfirmationPlatformDae"
>
  <mat-toolbar-row>
    <button (click)="opened = !opened" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <h4>SOLICITUD</h4>
    <span class="example-spacer"></span>
    <img src="assets/images/VEMO.png" alt="" class="imgbar" />
  </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav
    [(opened)]="opened"
    mode="over"
    *ngIf="!hidePageConfirmationPlatform && !hidePageConfirmationPlatformDae"
  >
    <mat-list>
      <mat-list-item class="center">
        <mat-icon class="white mr-8">brightness_5</mat-icon>
        <mat-slide-toggle [formControl]="toggleControl" class="mr-8">
        </mat-slide-toggle>
        <mat-icon class="white">bedtime</mat-icon>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <a href="https://vemo.mx/"> INICIO </a>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item>
        <a href="https://vemovilidad.com/arrendamiento-de-vehiculos-electricos/">
          VEMO IMPULSO
        </a>
      </mat-list-item>
      <mat-list-item>
        <a href="https://vemovilidad.com/conductores-de-vehiculos-electricos/">
          VEMO CONDUCE
        </a>
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-expansion-panel [hideToggle]="false">
        <mat-expansion-panel-header>
          <a class="resetFont"> NUEVA SOLICITUD </a>
        </mat-expansion-panel-header>
        <a
          class="resetFont"
          href="/mx/solicitud/form/bienvenida?creditType=1"
        >
          VEMO IMPULSO
        </a>
        <br />
        <br />
        <a class="resetFont" href="/mx/solicitud/bienvenida?creditType=9">
          VEMO CONDUCE
        </a>
      </mat-expansion-panel>
      <mat-list-item>
        <a href="/busqueda"> BUSCAR SOLICITUD </a>
      </mat-list-item>
      <mat-list-item>
        <a href="https://vemo.mx/contacto"> CONTACTO </a>
      </mat-list-item>
    </mat-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <div
      *ngIf="
        !hidePageConfirmationPlatform &&
        !hidePageConfirmationPlatformDae &&
        !search &&
        !authorization
      "
      class="container"
    >
      <div *ngIf="creditType$ === '9' || creditType$ === 'DAE'">
        <p class="text-title-lto">SOLICITUD CONDUCTOR VEMO</p>
        <h3>Completa tu solicitud con estos sencillos pasos</h3>
      </div>

      <div *ngIf="creditType$ === '1' || creditType$ === 'LTO'">
        <p class="text-title-lto">SOLICITUD ARRENDAMIENTO VEMO</p>
        <h3>
          Bienvenido a nuestro proceso, estás a unos pasos de convertirte en
          dueño de un auto!.
        </h3>
      </div>

      <div class="card">
        <div *ngIf="requestNumber$" class="card-header">
          NÚMERO DE SOLICITUD
        </div>
        <div *ngIf="requestNumber$" class="card-body">
          {{ requestNumber$ }}
        </div>

        <div *ngIf="referralName$">
          <p class="referralText">REFERIDO POR: {{ referralName$ }}</p>
        </div>
      </div>
    </div>

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
